var map = {
	"./icon-cart-white.svg": "f637",
	"./icon-cart.svg": "d965",
	"./icon-close.svg": "3c76",
	"./icon-delete.svg": "11ca",
	"./icon-menu.svg": "716d",
	"./icon-minus.svg": "b398",
	"./icon-next.svg": "69c6",
	"./icon-plus.svg": "77ea",
	"./icon-previous.svg": "90cb",
	"./image-avatar.png": "b10a",
	"./image-product-1-thumbnail.jpg": "8aca",
	"./image-product-1.jpg": "08c3",
	"./image-product-2-thumbnail.jpg": "8f55",
	"./image-product-2.jpg": "ca5b",
	"./image-product-3-thumbnail.jpg": "eef8",
	"./image-product-3.jpg": "8611",
	"./image-product-4-thumbnail.jpg": "0ceb",
	"./image-product-4.jpg": "dedb",
	"./logo.svg": "e347"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";